import "shepherd.js/dist/css/shepherd.css";
import "../../../resources/less/Troubadour/components/GuidedTutorialBase.less";
import Shepherd, { Tour } from "shepherd.js";
import { offset } from "@floating-ui/dom";

export default abstract class BaseDemoTour {
  protected tour: Tour;
  protected textContainer: HTMLElement;

  constructor() {
    this.tour = new Shepherd.Tour({
      defaultStepOptions: {
        floatingUIOptions: {
          middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
        },
        classes: "troub-construction-tutorial",
        scrollTo: true,
        scrollToHandler: (e) => {
          if (!e) {
            return;
          }
          $("html, body").animate(
            {
              scrollTop: $(e).offset().top - 100,
            },
            250,
          );
        },
      },
      exitOnEsc: true,
      useModalOverlay: true,
    }) as Tour;
  }

  public abstract Start(): void;
}
